// export action types
import { UPDATE_CHECKOUT_STATE, CLEAR_CHECKOUT_STATE } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { updateCheckoutState } from 'actions/updateCheckoutState';
 *
 * // dispatch action
 * store.dispatch( updateCheckoutState( payload ) );
 */
export const updateCheckoutState = ( payload ) => {
    return {
        type: UPDATE_CHECKOUT_STATE,
        payload: payload
    };
};

/**
 * @type {function}
 * @param {object} payload - Clear call state.
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { clearCheckoutState } from 'actions/updateCheckoutState';
 *
 * // dispatch action
 * store.dispatch( clearCallState() );
 */
export const clearCheckoutState = () => {
    return {
        type: CLEAR_CHECKOUT_STATE,
        payload: null
    };
};
